import { AuthDebugBadge } from '@/components/shared/AuthDebugBadge'
import { CompanySwitcher } from '@/components/shared/CompanySwitcher'
import { MobileSidebarSheet } from '@/components/shared/MobileSidebarSheet'
import { NotificationsBell } from '@/components/shared/NotificationsBell'
import { ThemeToggle } from '@/components/shared/ThemeToggle'
import { UserMenu } from '@/components/shared/UserMenu'
import { useWsStatus } from '@/lib/hooks/useWsStatus'
import { useCompanyStore } from '@/stores/company'
import { cn } from '@/lib/utils'

const WS_STATUS_CONFIG = {
  connected: {
    dot: 'bg-success',
    label: 'WebSocket connected',
  },
  connecting: {
    dot: 'bg-warning animate-pulse',
    label: 'Conectando ao WebSocket…',
  },
  disconnected: {
    dot: 'bg-destructive',
    label: 'WebSocket desconectado — usando polling',
  },
} as const

function WsStatusDot() {
  const companyId = useCompanyStore((s) => s.activeCompanyId)
  const status = useWsStatus(companyId)
  const { dot, label } = WS_STATUS_CONFIG[status]

  return (
    <span
      className={cn('inline-block h-2 w-2 shrink-0 rounded-full', dot)}
      title={label}
      aria-label={label}
    />
  )
}

export function Header() {
  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between gap-3 border-b border-border bg-card px-4 md:px-6">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <MobileSidebarSheet />
        <CompanySwitcher />
      </div>

      <div className="flex items-center gap-2">
        {/* VEC-194 — visualização do auth ao vivo (admin/dev). */}
        <AuthDebugBadge />
        {/* VEC-145 — indicador de status da conexão WebSocket. */}
        <WsStatusDot />
        {/* VEC-156 — toggle dark/light. */}
        <ThemeToggle />
        {/* VEC-155 — centro de notificações. */}
        <NotificationsBell />
        <UserMenu />
      </div>
    </header>
  )
}
